module.exports = __webpack_public_path__ + "static/media/attribute_heart.fe559275.png";